import { getDomain } from "@/lib/domain/api";
import { DOMAIN_STATUS } from "@/lib/enums";
import { CustomDomain } from "@/types";
import { useQuery } from "@tanstack/react-query";

export function useGetDomain(domainId: string) {
  return useQuery({
    queryKey: ["domain", domainId],
    queryFn: () => getDomain(domainId),
    select: (data) => data.data as CustomDomain,
    enabled: !!domainId,
    refetchInterval: (query) => {
      const domain = query.state.data as CustomDomain | undefined;
      if (
        !domain ||
        [DOMAIN_STATUS.ERROR, DOMAIN_STATUS.ACTIVE].includes(domain.sslStatus)
      ) {
        return false; // Return false to stop the refetch interval
      }
      return 5000;
    },
  });
}
